
<div class="admin-view">
  <page-header title="Admin" />

  <section>
    <h3>Users</h3>

    <div class="search-container">
      <form class="search-form" @submit.prevent="handleSearch">
        <align small-gap>
          <text-input
            v-model="searchQuery"
            label="Search Users"
            type="search"
            placeholder="Search by email or user ID..."
          />

          <btn
            type="submit"
            :loading="searching"
            :loading-text="searching ? 'Searching...' : 'Search'"
            :disabled="!searchQuery.trim()"
          >
            Search
          </btn>
        </align>
      </form>
    </div>

    <div class="create-container">
      <form class="create-form" @submit.prevent="handleCreate">
        <align small-gap>
          <text-input
            v-model="emailInput"
            label="Email"
            type="email"
            placeholder="Enter new user email"
          />

          <btn
            type="submit"
            :loading="creating"
            :loading-text="creating ? 'Creating...' : 'Create'"
            :disabled="!emailInput.trim()"
          >
            Create
          </btn>
        </align>
      </form>
    </div>
  </section>

  <form @submit.prevent="handleCreateFreeStripeAccount">
    <h3>Free Stripe Account</h3>

    <align class="free-account-input" flex>
      <div class="input-group">
        <text-input
          v-model="freeAccountEmail"
          label="Email"
          type="email"
          placeholder="Enter user email"
        />

        <text-input
          v-model="freeAccountCoupon"
          label="Stripe Coupon Code"
          placeholder="Enter Stripe coupon code"
        />
      </div>

      <btn
        type="submit"
        :loading="creatingFreeAccount"
        :loading-text="creatingFreeAccount ? 'Creating...' : 'Create Account'"
        :disabled="!freeAccountEmail.trim() || !freeAccountCoupon.trim()"
      >
        Create Account
      </btn>
    </align>
  </form>

  <form>
    <h3>Graded Cards</h3>

    <align class="cert-input" flex>
      <text-input
        v-model="certInput"
        label="Cert #"
        placeholder="63444200"
      />

      <select-input
        v-model="graderInput"
        label="Grader"
        :options="graderOptions"
      />

      <btn
        :loading="refreshingCert"
        loading-text="Submitting"
        :disabled="!certInput.trim() || !graderInput"
        @click="refreshCert"
      >
        Refresh Cert #
      </btn>
    </align>
  </form>
</div>
